import { render, staticRenderFns } from "./Trade.vue?vue&type=template&id=c4f77cac&scoped=true"
import script from "./Trade.vue?vue&type=script&lang=js"
export * from "./Trade.vue?vue&type=script&lang=js"
import style0 from "./Trade.vue?vue&type=style&index=0&id=c4f77cac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f77cac",
  null
  
)

export default component.exports